import { Spacer } from "tamagui";

import { ConfirmationAlertTestID, TasksTestID } from "@/constants/TestID";
import InsuranceOverviewCard from "@/ui/components/tasks/InsuranceOverviewCard";
import TaskBasicDetails from "@/ui/components/tasks/TaskBasicDetails";
import ConfirmationAlertModal from "@/ui/composed/alerts/ConfirmationAlert";
import { FAIconName } from "@/ui/core";

const baseTestID = TasksTestID.TaskDetails;

interface UploadInsuranceCardTaskDetailsProps {
  description?: string;
  duration: string;
  insuranceCardBack: string;
  insuranceCardFront: string;
  isAlertOpen: boolean;
  onAlertConfirm: () => void;
  onPressCard: (side: "back" | "front") => void;
  onToggleAlert: () => void;
  patientName?: string;
  title: string;
}

const UploadInsuranceCardTaskDetails = ({
  description,
  duration,
  insuranceCardBack,
  insuranceCardFront,
  isAlertOpen,
  onAlertConfirm,
  onPressCard,
  onToggleAlert,
  patientName,
  title,
}: UploadInsuranceCardTaskDetailsProps) => {
  return (
    <>
      <TaskBasicDetails
        description={description}
        duration={duration}
        patientName={patientName}
        testID={baseTestID}
        title={title}
      />
      <Spacer height={24} />
      <InsuranceOverviewCard
        cardSide="front"
        imageUrl={insuranceCardFront}
        onPress={() => onPressCard("front")}
        testID={baseTestID}
      />
      <Spacer height={12} />
      <InsuranceOverviewCard
        cardSide="back"
        imageUrl={insuranceCardBack}
        onPress={() => onPressCard("back")}
        testID={baseTestID}
      />
      <ConfirmationAlertModal
        confirmationType="destructive"
        confirmLeftIcon={FAIconName.Times}
        confirmText="Discard changes"
        isOpen={isAlertOpen}
        message="If you leave now, any files you’ve selected will be lost."
        onConfirm={onAlertConfirm}
        onDismiss={onToggleAlert}
        testID={ConfirmationAlertTestID.CancelUploadInsurance}
        title="Are you sure?"
      />
    </>
  );
};

export default UploadInsuranceCardTaskDetails;
